import { Stack, Typography } from '@mui/material';

import type { MultiAutocompleteBadgeCountProps } from './types';
import { Indicator } from '../../../indicators';
import { MultiAutocomplete } from '../MultiAutocomplete/MultiAutocomplete';

/**
 * Thin wrapper around MultiAutocomplete component that renders a badge count of selected items.
 */
export const MultiAutocompleteBadgeCount = <Item,>({
  items,
  size = 'medium',
  indicatorLabel = 'Selected items:',
  indicatorColor = 'blue',
  testId = 'multi-autocomplete-badge-count-root',
  ...props
}: MultiAutocompleteBadgeCountProps<Item>) => {
  return (
    <MultiAutocomplete
      {...(props as any)} // todo: fix casting
      testId={testId}
      size={size}
      items={items}
      renderSelectedItems={({ selectedItems }) => (
        <Stack
          data-testid="selection-indicator"
          direction="row"
          alignItems="center"
          spacing="8px"
        >
          <Typography
            variant={size === 'small' ? 'P12R' : 'P14R'}
            data-testid="badge-label"
          >
            {indicatorLabel}
          </Typography>
          <Indicator
            size={size}
            testId="badge-count"
            count={selectedItems.length}
            color={props.disabled ? 'grey' : indicatorColor}
          />
        </Stack>
      )}
    />
  );
};
